<template>
  <v-form>
      <v-text-field
        v-model="item.plainPassword"
        type="password"
        :error-messages="plainPasswordErrors"
        :label="$t('administration.user.plainPassword')"
        clearable
        prepend-icon="mdi-onepassword"
        required
        @input="$v.item.plainPassword.$touch()"
        @blur="$v.item.plainPassword.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="item.confirmPassword"
        type="password"
        :error-messages="confirmPasswordErrors"
        :label="$t('administration.user.confirmPassword')"
        clearable
        prepend-icon="mdi-onepassword"
        required
        @input="$v.item.confirmPassword.$touch()"
        @blur="$v.item.confirmPassword.$touch()"
      ></v-text-field>

  </v-form>
</template>

<script>
  import has from 'lodash/has';
  import { validationMixin } from 'vuelidate';
  import { required, sameAs } from 'vuelidate/lib/validators';
  export default {

    name: 'RegenPasswordForm',
    mixins: [validationMixin],
    props: {
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object,
        default: () => {}
      },
      initialValues: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        plainPassword: null,
        confirmPassword : null,
      }
    },
    computed: {

      // eslint-disable-next-line
      item() {
        return this.initialValues || this.values;
      },

      plainPasswordErrors() {
        const errors = [];

        if (!this.$v.item.plainPassword.$dirty) return errors;

        has(this.violations, 'plainPassword') && errors.push(this.violations.plainPassword);

        !this.$v.item.plainPassword.required && errors.push(this.$t('global.field_required'));

        return errors;
      },
      confirmPasswordErrors() {
        const errors = [];

        if (!this.$v.item.confirmPassword.$dirty) return errors;

        has(this.violations, 'confirmPassword') && errors.push(this.violations.confirmPassword);

        !this.$v.item.confirmPassword.required && errors.push(this.$t('global.field_required'));
        !this.$v.item.confirmPassword.sameAsPassword && errors.push(this.$t('administration.user.sameAsPassword'));

        return errors;
      },
      violations() {
        return this.errors || {};
      }
    },
    methods: {

    },
    validations: {
      item: {
        plainPassword: {
          required,
        },
        confirmPassword: {
          required,
          sameAsPassword: sameAs('plainPassword')
        },
      }
    }
  }
</script>
